import styles from "./FAQsSection.module.scss";
import useAppSelector from "../../../hooks/useAppSelector";
import SectionTitle from "../../../components/UI/SectionTitle/SectionTitle";

const FAQsSection = () => {

    const {content} = useAppSelector(state => state.siteContentSlice);

    const faqItems = content.faqItems ? JSON.parse(content.faqItems) : null;

    return (
        <section className={styles.section}>
            <SectionTitle text={"FAQs"}/>
            <div className={styles.box}>
                <div className={"container"}>
                    <div className={styles.wrapper}>
                        {
                            faqItems.map((item: any) => {
                                return (
                                    <div key={item.key} className={styles.item}>
                                        <h4 className={styles.itemTitle}>{item.label}</h4>
                                        <p className={styles.itemDescription}>{item.text}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </section>
    )

}

export default FAQsSection;